import axios from "axios";
import { endpoints } from "../env";

const api = axios.create({
  baseURL: endpoints.api,
});

export default api;